import http from './http';

export default {
    preparationsAndSubstances() {
        return http.get('/export/preparationsAndSubstances', { responseType: 'blob' });
    },
};
